/****************************************************
 * Module Name:  addQualityModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import QualityProxy from "../../utility/proxy/manager/qualityProxy";
import Constants from "../../utility/constants";
import logo from '../../images/pansuriya.jpg'
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import SaveIcon from '@mui/icons-material/Save';

export default class AddQualityModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newquality: this.props.editOperation ? this.props.sourceData.name : "",
      newtype: this.props.editOperation ? this.props.sourceData.type : "Normal",
      newdescription: this.props.editOperation
        ? this.props.sourceData.description
        : "",

      showError: false,

      validateQualityPresentSpinner: false,
      showValidationMessage: false,
      qualityAvailable: true,

      qualityValidationError: "",
      typeValidationError: "",
    };
  }

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      name: this.state.newquality,
      type: this.state.newtype,
      description: this.state.newdescription,
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateQualityPresent = (qualityEntered) => {
    if (!qualityEntered || qualityEntered.trim() === "") return;

    this.setState({
      validateQualityPresentSpinner: true,
    });

    QualityProxy.CheckQualityAvailable(qualityEntered, (response) => {
      //if we got response that means quality is present at backend
      if (response) {
        //QualityName already present
        this.setState({
          validateQualityPresentSpinner: false,
          showValidationMessage: true,
          qualityAvailable: false,
        });
      } else {
        //QualityName not available, so can be used
        this.setState({
          validateQualityPresentSpinner: false,
          showValidationMessage: true,
          qualityAvailable: true,
        });
      }
    });
  };

  buttonDisable = () => {
    if (this.props.editOperation && this.state.newtype.length === 0)
      return true;

    if (!this.props.editOperation)
      return (
        !this.state.showValidationMessage ||
        !this.state.qualityAvailable ||
        this.state.newtype.length === 0
      );

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add quality validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation ? "Edit Quality" : "Add New Quality"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  {this.props.editOperation && (
                    <tr>
                      <td>
                        <Form.Label>Quality Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.sourceData.id}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {this.props.editOperation && (
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <Form.Label>
                        Quality <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    {this.props.editOperation ? (
                      <td>
                        <Form.Label>{this.state.newquality}</Form.Label>
                      </td>
                    ) : (
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="Quality (required)"
                          placeholder="Enter Quality"
                          value={this.state.newquality}
                          autoFocus
                          onBlur={(e) =>
                            this.validateQualityPresent(this.state.newquality)
                          }
                          onChange={(e) =>
                            this.setState({
                              newquality: e.target.value,
                              showValidationMessage: false,
                              qualityValidationError: Utility.CheckIsPresent(
                                e.target.value
                              )
                                ? ""
                                : "Quality Cannot be Empty",
                            })
                          }
                          helperText={this.state.qualityValidationError}
                          error={this.state.qualityValidationError.length > 0}
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.state.validateQualityPresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box>&nbsp;</Box>
                      ) : this.state.qualityAvailable ? (
                        <font color="green">Quality available</font>
                      ) : (
                        <font color="red">Quality not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Type <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Type (required)"
                        placeholder="Enter Type"
                        value={this.state.newtype}
                        onChange={(e) =>
                          this.setState({
                            newtype: e.target.value,
                            typeValidationError: Utility.CheckIsPresent(
                              e.target.value
                            )
                              ? ""
                              : "Quality type Cannot be Empty",
                          })
                        }
                        helperText={this.state.typeValidationError}
                        error={this.state.typeValidationError.length > 0}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newdescription}
                        onChange={(e) =>
                          this.setState({ newdescription: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
